import React, { ChangeEvent, memo } from 'react';
import styled, { css } from 'styled-components';
import theme from '@styles/theme';

type StyledRadioProps = {
    radioId: string;
    label?: string;
    fontColor?: string;
    fontFamily?: string;
    margin?: string;
    name: string;
    value?: any;
    checked?: any;
    dataValue?: string;
    disabled?: boolean;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
};

const StyledRadio = ({
    radioId,
    label,
    margin,
    name,
    value,
    checked,
    onChange,
    dataValue = '',
    disabled,
    fontColor
}: StyledRadioProps) => {
    return (
        <Wrapper $margin={margin}>
            <Label htmlFor={radioId}>
                <Marker $checked={value === checked} />
                <Input
                    id={radioId}
                    type="radio"
                    name={name}
                    value={value}
                    onChange={onChange}
                    data-value={dataValue}
                    disabled={disabled}
                    checked={value === checked}
                />
                {label && (
                    <Text $fontColor={fontColor} $checked={value === checked}>
                        {label}
                    </Text>
                )}
            </Label>
        </Wrapper>
    );
};

export default memo(StyledRadio);

const Wrapper = styled.div<{ $margin?: string }>`
    display: flex;
    align-items: center;
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
`;
const Label = styled.label`
    color: ${theme.colors.grayFontColor};
    display: flex;
    align-items: center;
    cursor: pointer;
`;
const Marker = styled.div<{ $checked: boolean }>`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 1px solid ${theme.colors.lightGrayBorder};
    background-color: ${theme.colors.ultraLightGrayBorder};

    ${({ $checked }) =>
        $checked &&
        css`
            border: 5px solid ${theme.colors.positiveBlue};
            background-color: ${theme.colors.whiteColor};
        `};
`;
const Input = styled.input`
    display: none;
`;
const Text = styled.div<{ $fontColor?: string; $checked: boolean }>`
    margin-left: 12px;
    font-size: 14px;
    color: ${({ $fontColor }) =>
        $fontColor ? $fontColor : theme.colors.grayFontColor};
    ${({ $checked }) =>
        $checked &&
        css`
            color: ${theme.colors.blackColor};
        `};
`;
